export {NotepadModule} from './core/notepad.module';
export {NotepadService} from './core/notepad.service';
export {ServicesInstantiatorService as NotepadServicesInstantiatorService} from './core/services/services-instantiator.service';